import React from "react";
import {
  Flex,
  Image,
  Text,
  Heading,
  Link,
  Spacer,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

// 1. Define the shape of the article data
interface Article {
  title: string;
  image: string;
  excert: string;
  link: string;
}

// Create motion-enhanced Flex
const MotionFlex = motion(Flex);

const ArticleCard: React.FC<Article> = ({ title, image, excert, link }) => (
  <MotionFlex
    direction="column"
    borderWidth="1px"
    borderRadius="lg"
    overflow="hidden"
    boxShadow="lg"
    height="100%"
    initial={{ opacity: 0, y: 40, scale: 0.95 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }} // spring-like ease
  >
    <Image src={image} alt={title} objectFit="cover" w="100%" h="180px" />
    <Flex direction="column" p={4} flex="1">
      <Heading size="md" mb={2}>
        {title}
      </Heading>
      <Text mb={4} noOfLines={5}>
        {excert}
      </Text>
      <Spacer />
      <Link href={link} color="teal.500" isExternal mt="auto">
        Read more →
      </Link>
    </Flex>
  </MotionFlex>
);

export default ArticleCard;